import LegalPage, { Section, P, UL } from "@/components/legal/LegalPage";
import { SITE } from "@/lib/siteConfig";

/**
 * BORRADOR. Este texto describe cómo funciona hoy la plataforma, pero no
 * sustituye la revisión de un abogado. Antes de publicar hay que llenar los
 * datos de SITE (razón social, domicilio, correos) y validar el documento.
 */
export default function TermsPage() {
    return (
        <LegalPage
            title="Términos y condiciones"
            intro={`Estos términos regulan el uso de ${SITE.name} tanto para quienes crean una tienda como para quienes compran en ella.`}
            updatedAt={SITE.legalUpdatedAt}
        >
            <Section n={1} title="Quiénes somos y qué aceptas">
                <P>
                    {SITE.name} es una plataforma operada por {SITE.legalName},
                    con domicilio en {SITE.address}, que permite a cualquier
                    persona crear una tienda en línea, cobrar sus ventas y
                    gestionar sus envíos.
                </P>
                <P>
                    Al registrarte, crear una tienda o realizar una compra en
                    una tienda alojada en {SITE.domain}, aceptas estos términos.
                    Si no estás de acuerdo con ellos, no uses la plataforma.
                </P>
            </Section>

            <Section n={2} title="Definiciones">
                <UL
                    items={[
                        <>
                            <strong>Plataforma:</strong> el sitio {SITE.domain},
                            sus paneles y los servicios que ofrecemos.
                        </>,
                        <>
                            <strong>Vendedor:</strong> la persona o empresa que
                            crea una tienda y publica productos en ella.
                        </>,
                        <>
                            <strong>Comprador:</strong> quien adquiere un
                            producto en alguna de esas tiendas.
                        </>,
                        <>
                            <strong>Tienda:</strong> el espacio dentro de{" "}
                            {SITE.domain} donde un Vendedor publica y vende.
                        </>,
                    ]}
                />
            </Section>

            <Section n={3} title="Cuenta y registro">
                <UL
                    items={[
                        "Debes ser mayor de edad y tener capacidad legal para contratar.",
                        "La información que registras debe ser veraz y mantenerse actualizada.",
                        "Eres responsable de la actividad realizada desde tu cuenta y de mantener tu contraseña en secreto. Avísanos de inmediato si detectas un acceso no autorizado.",
                        "Una misma persona puede tener una sola tienda por cuenta.",
                    ]}
                />
            </Section>

            <Section n={4} title="Nuestro papel en la venta">
                <P>
                    {SITE.name} es un intermediario tecnológico. La compraventa
                    ocurre entre el Comprador y el Vendedor: es el Vendedor
                    quien describe el producto, fija su precio, cuenta con el
                    inventario y responde por la entrega, la garantía y la
                    calidad de lo que vende.
                </P>
                <P>
                    Nosotros ponemos la tecnología: la tienda, el cobro en
                    línea, la generación de guías de envío y el panel de
                    pedidos. No somos propietarios de los productos publicados
                    ni fabricantes de los mismos.
                </P>
            </Section>

            <Section n={5} title="Qué se puede vender">
                <P>
                    No está permitido publicar productos o contenidos que sean
                    ilegales, falsificados, robados, peligrosos o que infrinjan
                    derechos de terceros. Entre otros, quedan prohibidos:
                </P>
                <UL
                    items={[
                        "Armas, explosivos, drogas y sustancias controladas.",
                        "Medicamentos que requieran receta y suplementos sin registro sanitario.",
                        "Productos falsificados o que infrinjan marcas y derechos de autor.",
                        "Animales vivos, órganos y restos humanos.",
                        "Material sexual explícito, contenido que promueva el odio o la violencia.",
                        "Documentos oficiales, datos personales de terceros y credenciales de acceso.",
                        "Cualquier bien o servicio prohibido por la legislación mexicana.",
                    ]}
                />
                <P>
                    Podemos revisar las publicaciones y retirar aquellas que
                    incumplan estas reglas, así como suspender la tienda
                    responsable.
                </P>
            </Section>

            <Section n={6} title="Precios, cobros y pagos al Vendedor">
                <UL
                    items={[
                        "Los precios se muestran en pesos mexicanos (MXN) con IVA incluido y los fija el Vendedor.",
                        "Crear y mantener una tienda no tiene costo mensual, y no cobramos comisión sobre el monto vendido.",
                        "El Comprador paga el total de su pedido (productos más envío) a través del procesador de pagos que utilizamos. Los datos completos de la tarjeta nunca se almacenan en la plataforma.",
                        "Del monto cobrado, al Vendedor le corresponde el importe de sus productos menos la comisión que retiene el procesador de pagos por la transacción.",
                        "El importe del envío que pagó el Comprador se destina a cubrir la guía con la paquetería correspondiente.",
                        "El Vendedor es responsable de las obligaciones fiscales derivadas de sus ventas.",
                    ]}
                />
            </Section>

            <Section n={7} title="Envíos y entregas">
                <P>
                    Al momento de comprar, el Comprador ve las opciones de
                    envío disponibles con su costo y tiempo estimado de entrega,
                    y elige una. El Vendedor genera la guía desde su panel y
                    entrega el paquete a la paquetería.
                </P>
                <P>
                    Los tiempos de entrega son estimados de la paquetería y
                    pueden variar por causas ajenas a la plataforma. Si el
                    Vendedor lo activa, también existe la opción de entrega
                    acordada directamente entre las partes, sin costo de envío.
                </P>
            </Section>

            <Section n={8} title="Cancelaciones, devoluciones y reembolsos">
                <UL
                    items={[
                        "Mientras un pedido no se haya pagado, puede cancelarse sin costo.",
                        "Si un producto pagado ya no tiene existencias, el pedido se marca como sin stock y procede el reembolso al Comprador.",
                        "Las devoluciones por producto defectuoso, incompleto o distinto a lo publicado se resuelven con el Vendedor, quien debe atenderlas conforme a la Ley Federal de Protección al Consumidor.",
                        "Los reembolsos se realizan por la misma vía en que se hizo el pago.",
                    ]}
                />
            </Section>

            <Section n={9} title="Contenido que publicas">
                <P>
                    El Vendedor conserva la titularidad de sus textos, fotos,
                    marcas y logotipos, y declara contar con los derechos para
                    usarlos. Al publicarlos, nos otorga una licencia no
                    exclusiva y gratuita para mostrarlos dentro de la
                    plataforma y en materiales de promoción del propio servicio,
                    vigente mientras la tienda esté activa.
                </P>
            </Section>

            <Section n={10} title="Suspensión y terminación">
                <P>
                    Podemos suspender o cancelar una cuenta o una tienda que
                    incumpla estos términos, publique contenido prohibido,
                    engañe a los compradores o ponga en riesgo la seguridad de
                    la plataforma. Tú puedes dejar de usar el servicio cuando
                    quieras y solicitar la baja de tu cuenta.
                </P>
            </Section>

            <Section n={11} title="Disponibilidad del servicio">
                <P>
                    Trabajamos para que la plataforma esté disponible de forma
                    continua, pero no podemos garantizar que funcione sin
                    interrupciones ni errores. Podemos realizar mantenimientos,
                    cambios o mejoras que afecten temporalmente el servicio.
                </P>
            </Section>

            <Section n={12} title="Límite de responsabilidad">
                <P>
                    {SITE.name} no responde por la calidad, legalidad o entrega
                    de los productos vendidos por terceros, ni por los acuerdos
                    a los que lleguen Comprador y Vendedor fuera de la
                    plataforma. Nuestra responsabilidad se limita, en todo caso,
                    a los montos efectivamente cobrados a través del servicio
                    por la operación de que se trate. Nada de lo aquí dicho
                    limita los derechos que la ley reconoce a los consumidores.
                </P>
            </Section>

            <Section n={13} title="Datos personales">
                <P>
                    El tratamiento de los datos personales se explica en nuestro{" "}
                    <a
                        href="/privacidad"
                        className="text-primary font-medium hover:underline"
                    >
                        Aviso de privacidad
                    </a>
                    , que forma parte de estos términos.
                </P>
            </Section>

            <Section n={14} title="Cambios a estos términos">
                <P>
                    Podemos actualizar estos términos para reflejar cambios en
                    el servicio o en la ley. La versión vigente siempre estará
                    publicada en esta página con su fecha de actualización. Si
                    sigues usando la plataforma después de un cambio, se
                    entiende que lo aceptas.
                </P>
            </Section>

            <Section n={15} title="Ley aplicable y contacto">
                <P>
                    Estos términos se rigen por la legislación mexicana. Para
                    cualquier controversia, las partes se someten a los
                    tribunales competentes de {SITE.address}, sin perjuicio de
                    que los consumidores puedan acudir a la Procuraduría
                    Federal del Consumidor (PROFECO).
                </P>
                <P>
                    Para dudas sobre estos términos, escríbenos a{" "}
                    <span className="font-medium text-[#1A1A1A]">
                        {SITE.contactEmail}
                    </span>
                    .
                </P>
            </Section>
        </LegalPage>
    );
}
